import { useLang } from '../../../../../../hooks/use-lang';
import { DashboardEmptyIcon } from './dashboard-empty-icon';
import s from './dashboard-empty.module.css';

export const DashboardEmpty = () => {
  const { t } = useLang();
  
  return (
    <div className={s.feature}>
      <DashboardEmptyIcon />
      <h3 className={s.label}>{t('По выбранному периоду данные отсутствуют')}</h3>
      <h4 className={s.subLabel}>
        {t(
          'Попробуйте выполнить поиск по другому периоду или выберите более широкий диапазон по дате и времени',
        )}
      </h4>
    </div>
  );
};
